$(document).ready(function(){
$('.main-box-slide').slick({   
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  arrows: false,                  
});

$('.slider-video').slick({
  infinite: true,
  slidesToShow: 2,
  slidesToScroll: 1,
  arrows:false,
  dots:false,
  responsive: [ 
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1    
      }
    }     
  ]
});

if (window.innerWidth <= 768) { // Agar viewport width 768 se chhota hai (mobile device)
  $('.cus-videos-text-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    responsive: [ 
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2    
        }
      }     
    ]
  });
}
  $('.customer-review-slider').slick({
  slidesToShow: 1,
  dots:true,
  arrows: false,
  centerMode: true,
  autoplay:true,
  autoplaySpeed:3000
  });

  // Check if the screen width is less than or equal to 768 pixels (considered as mobile device width)
  if($(window).width() <= 768) {
    $('.customer-featured-logo-slider').slick({
      slidesToShow: 1,
      dots: false,
      arrows: false,
      // centerMode: true,
      autoplay: true,
      autoplaySpeed: 3000
    });
  }  
})